import * as SC from './styled';

interface IDescriptionArea {
  caption: string;
  headline: string;
  content: string;
  ctaText: string;
}

const DescriptionArea = ({
  caption,
  headline,
  content,
  ctaText,
}: IDescriptionArea) => {
  return (
    <SC.ContentBlock>
      <p>{caption}</p>
      <h2>{headline}</h2>
      <p>{content}</p>
    </SC.ContentBlock>
  );
};

export default DescriptionArea;
